import { useState } from 'react';

import { useSelector } from 'react-redux';

import { GroupMappingConfig } from './components/GroupMappingConfig/GroupMappingConfig';
import { List } from 'components/List/List';
import { Loading } from 'components/Loading/Loading';
import { StatusPill } from 'components/Pills/StatusPills';

import { selectCompany } from 'api/company-slice';
import {
  useGetDirectoryGroupsQuery,
  useUpdateDirectoryGroupMappingMutation,
} from 'api/directory-groups-api';
import { selectRoles } from 'api/roles-slice';
import { selectTeams } from 'api/teams-slice';

export const GroupMappingTab = () => {
  const company = useSelector(selectCompany);
  const roles = useSelector(selectRoles);
  const teams = useSelector(selectTeams);

  const isConnected = !!company?.ad_sync_directory_id;

  const { data: groups = [], isFetching } = useGetDirectoryGroupsQuery(undefined, {
    skip: !isConnected,
  });
  const [updateMapping] = useUpdateDirectoryGroupMappingMutation();

  const [selectedGroupId, setSelectedGroupId] = useState();

  const selectedGroup = groups.find(group => group.workos_group_id === selectedGroupId);

  const onUpdate = async (workosGroupId, data) => {
    await updateMapping({ workosGroupId, data }).unwrap();
  };

  if (!isConnected) {
    return (
      <div className="card card-with-border u-padding--large u-text-centered">
        <p className="t-body u-font-weight-600">No directory connected</p>
        <p className="t-small secondary-text">
          Connect your company's directory from Company settings &gt; Authentication &amp; Security
          &gt; Active Directory to map its groups here.
        </p>
      </div>
    );
  }

  if (isFetching) {
    return <Loading active />;
  }

  return (
    <div className="d-flex">
      <List
        title="Directory Groups"
        subtitle="Map directory groups to Checkmate roles and teams."
        className="u-margin-right--large">
        <List.Category title="Groups" withCount>
          {groups.map(group => (
            <List.Item
              key={group.workos_group_id}
              title={group.name}
              value={group.workos_group_id}
              onClick={setSelectedGroupId}
              action={
                <StatusPill
                  status={group.mapped ? 'success' : 'warning'}
                  text={group.mapped ? 'Mapped' : 'Needs mapping'}
                />
              }
            />
          ))}
        </List.Category>
      </List>
      {selectedGroup && (
        <GroupMappingConfig
          group={selectedGroup}
          roles={roles}
          teams={teams}
          onUpdate={onUpdate}
          onClose={() => setSelectedGroupId(undefined)}
        />
      )}
    </div>
  );
};
